import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useStore } from "../context/StoreContext";
import { Lines, FadeUp } from "../components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const { clearCart } = useStore();
    const [state, setState] = useState("polling");
    const tries = useRef(0);
    const sessionId = params.get("session_id");

    useEffect(() => {
        if (!sessionId) {
            setState("error");
            return;
        }
        let timer;
        const poll = async () => {
            try {
                const r = await axios.get(`${API}/payments/status/${sessionId}`);
                if (r.data.payment_status === "paid") {
                    setState("paid");
                    clearCart();
                    return;
                }
            } catch {}
            tries.current += 1;
            if (tries.current < 15) {
                timer = setTimeout(poll, 2000);
            } else {
                setState("timeout");
            }
        };
        poll();
        return () => clearTimeout(timer);
    }, [sessionId, clearCart]);

    return (
        <div data-testid="payment-success-page" className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
            {state === "polling" && (
                <p data-testid="payment-confirming" className="animate-pulse text-[10px] uppercase tracking-[0.4em] text-[#8E8D8A]">
                    Confirming your payment
                </p>
            )}
            {state === "paid" && (
                <>
                    <p className="text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Payment Confirmed</p>
                    <h1 className="font-display mt-6 text-4xl font-black uppercase tracking-tighter text-[#0A0A0A] sm:text-6xl">
                        <Lines lines={["Welcome To", "The Club."]} />
                    </h1>
                    <FadeUp delay={0.3}>
                        <p className="mt-8 max-w-sm text-xs leading-relaxed text-[#8E8D8A]">
                            Your order is confirmed and paid. A receipt is on its way to your email. Your pieces ship from
                            Canada within 48 hours.
                        </p>
                        <Link
                            data-testid="success-continue-shopping"
                            to="/shop"
                            className="link-underline mt-10 inline-block font-display text-[11px] font-bold uppercase tracking-[0.35em] text-[#0A0A0A]"
                        >
                            Continue Shopping
                        </Link>
                    </FadeUp>
                </>
            )}
            {(state === "timeout" || state === "error") && (
                <>
                    <p className="text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Payment Received</p>
                    <p className="mt-6 max-w-sm text-xs leading-relaxed text-[#8E8D8A]">
                        Your payment is being processed and will confirm shortly. If you have questions, contact
                        club@vantageowners.com with your session reference.
                    </p>
                    <Link
                        to="/"
                        className="link-underline mt-10 inline-block font-display text-[11px] font-bold uppercase tracking-[0.35em] text-[#0A0A0A]"
                    >
                        Back Home
                    </Link>
                </>
            )}
        </div>
    );
}
